// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2jlRs","serial":"serial___z7J1I","link":"link___1U_pv"};